<template lang="pug">
  router-link(:event="disabled?'':'click'" @mousedown.native="mouseDownHandler" @click.native="clickHandler" :to="to" ).UndraggableRouterLink
    slot
</template>

<script>

export default {
  props: {
    to: {
      type: String,
      required: true
    },
    onClick: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      disabled: false // active ou désactive le lien
    }
  },
  beforeDestroy () {
    window.removeEventListener('mousemove', this.mouseMoveHandler)
  },
  methods: {
    /**
     * Callback lors d'un évènement mouse down
     */
    mouseDownHandler (e) {
      // On écoute si l'utilisateur drag la souris
      window.addEventListener('mousemove', this.mouseMoveHandler)
    },
    /**
     * Callback lors d'un évènement mouse move
     */
    mouseMoveHandler (e) {
      // on désactive le link car l'utilisateur a draggé depuis le mouse down
      this.disabled = true
      // on empèche le comportement par défaut du navigateur qui permet de dragger un link
      e.preventDefault()
    },
    clickHandler (e) {
      // Seulement si c'est un vrai click
      if (!this.disabled) {
        // On appel le callback
        this.onClick(e)
      }

      // on réactive le link par défaut
      this.disabled = false
      // on arrête d'écouter l'évènement mouse move
      window.removeEventListener('mousemove', this.mouseMoveHandler)
    }
  }
}

</script>

<style lang="stylus" scope>
</style>
